export enum PaymentSchemesStatus {
  Active,
  Inactive,
}
